import React, { useEffect } from "react";
import Header from "../../components/Header";
import NewsDetailsMain from "./NewsDetailsMain";
import Footer from "../../components/Footer";
import { useLocation } from "react-router";
import { getNewsById, getAllNews } from "../../services/newsServices";
import { useQuery } from "@tanstack/react-query";

const NewsDetails = () => {
  useEffect(() => {
    document.title = "News Details | Society of Aquaculture Professionals";
  }, []);

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = params.get("id");

  const {
    data: news,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["news", id],
    queryFn: () => getNewsById(id),
    enabled: !!id,
  });

  const {
    data: allNews,
    isLoading: allNewsLoading,
    isError: allNewsError,
  } = useQuery({
    queryKey: ["all-news"],
    queryFn: () => getAllNews({ limit: 3 }),
  });

  const location = useLocation();

  // Extract query params from URL
  const queryParams = new URLSearchParams(location.search);
  const urlTitle = queryParams.get("title") || "News Details";
  const formattedTitle = decodeURIComponent(urlTitle.replace(/\+/g, " "));

  return (
    <>
      <Header />

      <NewsDetailsMain
        news={news?.data}
        isLoading={isLoading}
        isError={isError}
        relatedNews={allNews?.data?.items || []}
        relatedLoading={allNewsLoading}
        relatedError={allNewsError}
        formattedTitle={formattedTitle}
      />

      <Footer />
    </>
  );
};

export default NewsDetails;
